export default __webpack_public_path__ + "static/media/536.272c945e.png";